import React from 'react';
import { useNavigate } from 'react-router-dom';

// WEB DEMO ONLY: replaces the sign-in page. Nothing is checked - the visitor is the
// admin of a sample property.
function DemoStart() {
  const navigate = useNavigate();
  function start() {
    import('./demoEngine').then(m => {
      const who = m.DEMO_PEOPLE.admin;
      try {
        localStorage.setItem('admin_token', who.token);
        localStorage.setItem('admin_name', who.name);
        localStorage.setItem('admin_role', who.role);
      } catch (e) { /* private window: the demo still works for this visit */ }
      navigate('/dashboard');
    });
  }
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#0f0f1a', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px 16px', gap: '24px', boxSizing: 'border-box' }}>
      <div style={{ width: '100%', maxWidth: '460px', backgroundColor: '#ffffff', borderRadius: '16px', padding: '20px 18px', boxSizing: 'border-box' }}>
        <img src="/logo.png" alt="EZ Pace" style={{ width: '100%', display: 'block' }} />
      </div>
      <div style={{ width: '100%', maxWidth: '460px', backgroundColor: '#16213e', borderRadius: '16px', padding: '28px 24px', boxSizing: 'border-box' }}>
        <div style={{ color: '#ffcc00', fontSize: '12px', fontWeight: 'bold', letterSpacing: '2px', marginBottom: '8px' }}>DEMO · DASHBOARD</div>
        <div style={{ color: '#ffffff', fontSize: '20px', fontWeight: 'bold', marginBottom: '10px' }}>Demo Casino</div>
        <div style={{ color: '#c0c0d0', fontSize: '15px', lineHeight: 1.55, marginBottom: '22px' }}>
          You are <b style={{ color: '#ffffff' }}>Alex</b>, the casino's EZ Pace admin. Ten weeks of sample tests are already in -
          plus any test you record on the floor app. Sample data only - nothing leaves this browser.
        </div>
        <button onClick={start} style={{ width: '100%', padding: '16px', backgroundColor: '#e94560', border: 'none', borderRadius: '10px', color: '#ffffff', fontSize: '17px', fontWeight: 'bold', cursor: 'pointer' }}>
          Open the dashboard
        </button>
      </div>
    </div>
  );
}

export default DemoStart;
